import { Domain } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/domain_pb';
import { GlobalPermission } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/global_permission_pb';
import { kleosPromiseClient } from '~/services/kleos-client';

export const PULSE_KLEOS_DOMAIN = Domain.ICS;

const GLOBAL_PERMISSIONS_PAGE_SIZE = 1000;

export const listMyGlobalPermissions = async () =>
  await kleosPromiseClient.listMyGlobalPermissions({});

const listGlobalPermissionsPage = async ({
  subjectName,
  pageToken,
}: {
  subjectName?: string;
  pageToken: string;
}): Promise<GlobalPermission[]> => {
  const response = await kleosPromiseClient.listGlobalPermissions({
    domain: PULSE_KLEOS_DOMAIN,
    subjectName: subjectName ?? '',
    pageSize: GLOBAL_PERMISSIONS_PAGE_SIZE,
    pageToken,
  });

  if (!response.nextPageToken) {
    return response.globalPermissions;
  }

  const remainingPages = await listGlobalPermissionsPage({
    subjectName,
    pageToken: response.nextPageToken,
  });

  return [...response.globalPermissions, ...remainingPages];
};

export const listGlobalPermissions = async ({
  subjectName,
}: {
  subjectName?: string;
} = {}) =>
  await listGlobalPermissionsPage({
    subjectName,
    pageToken: '',
  });

export const setGlobalPermissions = async ({
  subjectName,
  permissions,
}: {
  subjectName: string;
  permissions: GlobalPermission['permissions'];
}) =>
  await kleosPromiseClient.setGlobalPermission({
    globalPermission: {
      subjectName,
      domain: PULSE_KLEOS_DOMAIN,
      permissions,
    },
  });

export const revokeAllGlobalPermissions = async ({
  subjectName,
}: {
  subjectName: string;
}) =>
  await kleosPromiseClient.revokeGlobalPermission({
    subjectName,
    domain: PULSE_KLEOS_DOMAIN,
    permissions: [],
  });
